import Helper from '@ember/component/helper';

export function objectKeyLength([obj]: [Record<string, any> | null]) {
  if (obj == null) {
    return 0;
  }

  return Object.keys(obj).length;
}

/*
  Basic Usage:

  ```handlebars
  {{object-key-length someObject}}
  ```
*/
export default Helper.helper(objectKeyLength);
